import axios from "axios";
import { useState } from "react";
import { NavLink } from "react-router-dom";
import Nav from "../process/Nav";
import { url } from "../link";
const Addcontent = () => {
  const [stid, setstid] = useState("");
  const [content, setcontent] = useState("");
  const [samplecode, setsamplecode] = useState("");
  const [output, setoutput] = useState("");
  const [workout, setworkout] = useState("");
  const submitdata = () => {
    const value = {
      stid: stid,
      content: content,
      samplecode: samplecode,
      sampleoutput: output,
      workout: workout,
    };
    axios.post(url + "/edusphere/insertcontent", value);
    alert("success");
    setstid("");
    setcontent("");
    setsamplecode("");
    setoutput("");
    setworkout("");
  };
  return (
    <div>
      <Nav />
      <nav
        className="navbar navbar-expand-sm bg-success navbar-dark"
        style={{ marginTop: "5%" }}
      >
        <div className="collapse navbar-collapse" id="navbarResponsive">
          <ul className="navbar-nav">
            <li className="nav-item">
              <NavLink className="nav-link" to="/viewsubject">
                Subject
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink className="nav-link" to="/viewtopics">
                Topics
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink className="nav-link" to="/viewsubtopics">
                Subtopics
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink className="nav-link" to="/viewcontent">
                Content
              </NavLink>
            </li>
          </ul>
        </div>
      </nav>
      <nav
        className="navbar navbar-expand-sm bg-success navbar-dark"
        style={{ marginTop: "5%" }}
      >
        <div className="collapse navbar-collapse" id="navbarResponsive">
          <ul className="navbar-nav">
            <li className="nav-item">
              <NavLink className="nav-link" to="/addcontent">
                Addcontent
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink className="nav-link" to="/viewcontent">
                Viewcontent
              </NavLink>
            </li>
          </ul>
        </div>
      </nav>
      <h1>Add content</h1>
      <div className="form-floating mb-3 mt-3">
        <input
          type="text"
          className="form-control"
          onChange={(e) => setstid(e.target.value)}
          value={stid}
          placeholder="Enter stid"
        />
        <label htmlFor="stid">stid</label>
      </div>

      <div className="form-floating mb-3 mt-3">
        <textarea
          onChange={(e) => setcontent(e.target.value)}
          value={content}
          placeholder="Enter content"
        ></textarea>
      </div>

      <div className="form-floating mb-3 mt-3">
        <textarea
          onChange={(e) => setsamplecode(e.target.value)}
          value={samplecode}
          placeholder="Enter samplecode"
        ></textarea>
      </div>

      <div className="form-floating mb-3 mt-3">
        <textarea
          onChange={(e) => setoutput(e.target.value)}
          value={output}
          placeholder="Enter output"
        ></textarea>
      </div>

      <div className="form-floating mb-3 mt-3">
        <textarea
          onChange={(e) => setworkout(e.target.value)}
          value={workout}
          placeholder="Enter workout"
        ></textarea>
        <label htmlFor="workout">workout</label>
      </div>

      <input
        type="submit"
        className="btn btn-primary"
        onClick={submitdata}
        style={{ width: "100%" }}
      />
    </div>
  );
};
export default Addcontent;
